<template>
    <button
        type="button"
        class="mt-2 inline-flex w-full items-center justify-between rounded-[6px] border border-gray-300 bg-white py-2.5 pl-2.5 pr-4 text-sm font-medium text-gray-600 shadow-sm transition duration-100 ease-in-out hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 disabled:opacity-50"
        :disabled="loading"
        @click="$emit('export')"
    >
        <div class="flex items-center">
            <img :src="imagePath" class="h-6 w-6" alt="" />

            <span class="mx-2 text-left"
                >{{ label }}
                {{ integration.name ? "'" + integration.name + "'" : '' }}</span
            >
        </div>

        <div v-if="!loading">
            <svg
                width="6"
                height="10"
                viewBox="0 0 6 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1 1.5L4.46447 4.96447L1 8.42893"
                    stroke="#9FA6B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>

        <div v-else>
            <LoadingSpinner delay size="small" />
        </div>
    </button>
</template>

<script lang="ts" setup>
import { PropType, computed } from 'vue';
import { IIntegration } from '@/types/Integrations/IIntegration';

const CDN = 'https://d1vyenbk43iobe.cloudfront.net/application/images';

/**
 * Integrations whose `{type}.png` on the CDN is a wordmark rather than an icon.
 * They got a square variant uploaded next to it; everything else is square
 * already and resolves through the plain name.
 */
const SQUARE_LOGOS: Record<string, string> = {
    SENDY: 'sendy_square',
    ACTIVE_CAMPAIGN: 'active_campaign_square',
    KLAVIYO: 'klaviyo_square',
    MAILJET: 'mailjet_square',
    GMAIL: 'gmail_square',
    CLICKSEND: 'clicksend_square',
    BENCHMARK_EMAIL: 'benchmark_email_square2',
    MAILUP: 'mailup_square',
};

const props = defineProps({
    integration: {
        type: Object as PropType<IIntegration<unknown>>,
        required: true,
    },
    loading: {
        type: Boolean,
        default: false,
    },
});

defineEmits(['export']);

const imagePath = computed(
    () =>
        `${CDN}/${SQUARE_LOGOS[props.integration.type] ?? props.integration.type.toLowerCase()}.png`
);

const label = computed(() =>
    props.integration.type
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase())
);
</script>
